import { IconNames, l } from '@manychat/manyui'

import { KnowledgeEntryType } from 'shared/api/requests/aiBusinessKnowledge/schemas'

interface KnowledgeActionOption {
  icon: IconNames
  title: string
  description: string
  entryType: KnowledgeEntryType
  ariaLabel: string
  'data-test-id'?: string
}

export const KnowledgeTypeOptions: KnowledgeActionOption[] = [
  {
    icon: 'Link',
    title: l.translate('Add link'),
    description: l.translate('AI pulls information from any link you copy paste'),
    entryType: KnowledgeEntryType.LINK,
    ariaLabel: l.translate('Create link entry'),
  },
  {
    icon: 'BuilderText',
    title: l.translate('Add text'),
    description: l.translate('Add the details only you know'),
    entryType: KnowledgeEntryType.TEXT,
    ariaLabel: l.translate('Create text entry'),
    'data-test-id': 'ai-automation/add-first-text-entry',
  },
]
